import api from './api';

const authService = {

  // ---------- REGISTER ----------
  register: async (userData) => {
    const payload = {
      full_name: userData.full_name,
      username: userData.email,   // backend accepts username/email
      email: userData.email,
      password: userData.password,
    };

    const response = await api.post('/auth/register', payload);
    return response.data;
  },

  // ---------- LOGIN ----------
  login: async (credentials) => {
    // ✅ HARD GUARD: prevent empty / duplicate calls
    if (!credentials?.username || !credentials?.password) {
      throw new Error('Username and password are required');
    }

    const response = await api.post('/auth/login', {
      username: credentials.username,
      password: credentials.password,
    });

    // ✅ SAFETY CHECK
    if (!response?.data?.data) {
      throw new Error('Invalid login response');
    }

    const { user, access_token, refresh_token } = response.data.data;

    // Store tokens
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    localStorage.setItem('user', JSON.stringify(user));

    return response.data;
  },

  // ---------- LOGOUT ----------
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
  },

  // ---------- CURRENT USER ----------
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data.data;
  },

  // ---------- CHANGE PASSWORD ----------
  changePassword: async (passwordData) => {
    const response = await api.put('/auth/change-password', passwordData);
    return response.data;
  },

  // ---------- AUTH HELPERS ----------
  isAuthenticated: () => {
    return Boolean(localStorage.getItem('access_token'));
  },

  getUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },
};

export default authService;
